export default "__VITE_ASSET__CME4sLzf__"